import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { REGBR_METRIC_NAV } from '../regbr.models';

@Component({
  selector: 'app-regbr-metric-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslocoPipe, LocalizedRouterLinkPipe],
  template: `
    <section>
      <p class="mb-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {{ 'pages.regbr.metrics.selectLabel' | transloco }}
      </p>
      <div
        role="tablist"
        class="inline-flex flex-wrap items-center gap-1 rounded-full border border-border bg-muted/50 p-1 text-sm"
      >
        @for (metric of metrics; track metric.key) {
          <a
            role="tab"
            routerLinkActive
            #rla="routerLinkActive"
            [routerLink]="('/regbr/metricas/' + metric.key) | localizedRouterLink"
            [attr.aria-selected]="rla.isActive"
            class="rounded-full px-4 py-1.5 font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
            [class.bg-primary]="rla.isActive"
            [class.text-primary-foreground]="rla.isActive"
            [class.shadow-sm]="rla.isActive"
            [class.text-muted-foreground]="!rla.isActive"
            [class.hover:text-foreground]="!rla.isActive"
          >
            {{ metric.labelKey | transloco }}
          </a>
        }
      </div>
    </section>
  `,
})
export class RegbrMetricNavComponent {
  protected readonly metrics = REGBR_METRIC_NAV;
}
